module.exports = __webpack_public_path__ + "media/images/favicons/favicon-monday-32x32-3aa1eb3bd329bfb8109121586a33f8a2.png";